import { Component, OnInit, ViewChild } from '@angular/core';
import { Config } from '../../shared/models/config.model';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';
import { UsuarioService } from '../../shared/services/usuario/usuario.service'
import {
  AuthModel
} from 'src/app/shared/models/auth/auth.model';
import { UserModel } from 'src/app/shared/models/auth/user.model';
import { environment } from 'src/environments/environment';
import { ModalClientComponent } from './modal-client/modal-client.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { parameterProviderFactory } from 'src/app/app.module';
import { ConfigClienteService } from 'src/app/shared/services/config-cliente/config-cliente.service';
import { UsuarioWebModel, Data as DataUsuario } from 'src/app/shared/models/auth/usuario-web.model';
import {
  ClienteUsuarioModel,
  Data as DataClient,
  Cliente,
  Sucursale,
} from 'src/app/shared/models/auth/cliente-usuario.model';
import { SucursalService } from 'src/app/shared/services/sucursal/sucursal.service';
import { SocketConnectionService } from 'src/app/shared/services/socketConnection/socket-connection.service';
import { ErrorService } from 'src/app/shared/services/error/error.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public usuariosGuardados: string[];
  public config: Config;
  public show: boolean = false;
  public loginForm: FormGroup;
  public errorMessage: any;
  private unsubscribe: Subscription[] = [];
  private accessToken: string = '';
  // SC CATWEB-343 28/09/2021 Variable identifica si el usuario invitado esta activo.
  public invitado: boolean = false;
  private usuario: any;

  private usuarioWeb: DataUsuario;
  private clienteWeb: DataClient[];

  //MV CAT-53 Titulo y texto login
  public tituloLogin: string;
  public textoLogin: string;

  public today: number = Date.now();
  public version:string = environment.version;


  constructor(
    private configService: ConfigService,
    public authService: AuthService,
    private fb: FormBuilder,
    public router: Router,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private configClienteService: ConfigClienteService,
    private usuarioService: UsuarioService,
    private socketConn: SocketConnectionService,
    private errorService: ErrorService,
    private updateSW: SwUpdate
  ) {
    this.updateSW.available.subscribe((event) => {
      this.updateSW.activateUpdate().then(() => document.location.reload());
    });
    // SC CATWEB-324 inicializacion y definicion de validacion para los campos del formulario de loguin.
    this.loginForm = this.fb.group({
      usuario: ['', [Validators.required, Validators.maxLength(25)]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(16),
        ],
      ],
      recordarme: [true],
    });
  }

  ngOnInit() {
    this.config = this.configService.config;
    // SC CATWEB-343 28/09/2021 setea si esta activo el ingreso usuario invitado.
    this.invitado = this.config.sesion.invitado.active;

    // MV CATWEB-322 Se cargan los usuarios guardados para sugerirlos

    this.cargarUsuariosRecordados();

    this.tituloLogin = this.configService.config.cliente.titulo_login;
    this.textoLogin = this.configService.config.cliente.texto_login;
  }

  showPassword() {
    this.show = !this.show;
  }

  // SC CATWEB-324 logion de usuario api 2021.1.2.0
  // login() {

  //   const { usuario, password } = this.loginForm.value;

  //   const loginSub = this.authService.login(usuario, password)
  //     .subscribe(resp => {
  //       //console.log(resp);
  //       if (resp! > 0) {
  //         this.router.navigateByUrl('/home');
  //       } else {
  //         this.toastr.error(`${resp}`);
  //       }

  //     });
  //   this.unsubscribe.push(loginSub);

  //}
  // SC CATFER-9 Nuevo login utilizando recursos de API c# /Login , /UsuarioWeb/id/ObtenerCliente /UsuarioWeb/id,
  login() {
    const { usuario, password } = this.loginForm.value;
    const loginSub = this.authService
      .login(usuario, password)
      .subscribe((resp) => {
        if (resp.Succeeded) {
          this.recordarUsuario(usuario);
          this.accessToken = resp.Data.Token;
          this.getUsuarioWeb(resp.Data.IdUsuarioWeb, this.accessToken);
          this.usuarioService
            .getClientes(resp.Data.IdUsuarioWeb, this.accessToken)
            .subscribe((c) => {
              if (c.Succeeded) {

                this.clienteWeb = c.Data;

                let cantClient = this.clienteWeb.length;
                if (cantClient == 0) {
                  // SC CATWEB-332 Mensaje de error cuando no hay clientes asociados.
                  this.toastr.error(`Usuario sin cliente asociado`);
                } else if (cantClient == 1) {
                  console.log("entro sin usuario");
                  if (this.checkSucursal(this.usuarioWeb.PlataformaIntegracion.ModoPorSucursal, this.clienteWeb[0].Sucursales, this.clienteWeb[0].Cliente.NombreComercial)) {

                    // SC CATWEB-332 caso que solo tenga un cliente setean los datos e inicia sesion.
                    this.usuario = this.setUserClient(
                      this.usuarioWeb,
                      this.clienteWeb[0]
                    );
                    this.authService.setAuthFromLocalStorage(this.usuario);
                  if (this.invitado) {
                    this.pageRedirect(
                      this.config.sesion.invitado.page_inicio_invitado
                    );
                  } else {
                    this.pageRedirect(this.config.sesion.page_inicio_cliente);
                  }
                }
                } else {
                  // SC CATWEB-332 Se abre modal con el arreglo de clientes para ser seleccionados.
                  const modalRef = this.modalService.open(
                    ModalClientComponent,
                    {
                      size: 'lg',
                      centered: true,
                    }
                  );
                  modalRef.componentInstance.clients = this.clienteWeb;
                  modalRef.result.then((result) => {
                    // SC CATWEB-332 obtiene cliente, resultado de la seleccion, y procede a inicia sesion.
                    this.clienteWeb = [result];

                    if (this.checkSucursal(this.usuarioWeb.PlataformaIntegracion.ModoPorSucursal, this.clienteWeb[0].Sucursales, this.clienteWeb[0].Cliente.NombreComercial)) {
                    this.usuario = this.setUserClient(
                      this.usuarioWeb,
                      this.clienteWeb[0]
                    );
                    this.authService.setAuthFromLocalStorage(this.usuario);
                    this.pageRedirect(this.config.sesion.page_inicio_cliente);

                    //PM CATFER-54
                    // this.socketConn.InicializarConnection();
                    }
                  });
                }
              }
            });

        } else {
          let status = resp.status;
          if (status == 400 && resp.error.Errors) {
            // SC CATWEB-332 Mensaje de error retorna la API, datos de usuario incorrectos.
            this.toastr.error(`${resp.error.Errors[0]}`);
          } else {
            this.errorService.getError(status);
            // this.toastr.error(`${resp.error.Errors}`);
          }
        }
      });
    this.unsubscribe.push(loginSub);
  }

  // SC CATFER-9  funcion que setea los valores que seran almacenados en local storage miestras el usuario este logueado..
  private setUserClient(user: DataUsuario, client: DataClient) {
    let id_sucursal = user.PlataformaIntegracion.ModoPorSucursal == 'S' ? client.Sucursales[0].Id: 1;

    // SC CATWEB-343 28/09/2021 Se define si el usuario logueado es o no invitado.
    this.invitado =
      this.invitado && user.Usuario == this.config.sesion.invitado.user_invitado
        ? true
        : false;

    return {
      id_cliente: client.Cliente.Id,
      usuario: user.Usuario,
      email:user.Email,
      id_usuario_web: user.Id,
      id_plataforma: user.IdPlataformaIntegracion,
      invitado: this.invitado, // SC CATWEB-343 28/09/2021 Se agrega el valor de invitado a los datos del usuario logueado, true es cliente ocasional, false es cliente.
      token: this.accessToken,
      ids_sucursales: id_sucursal,
      modo_por_sucursal:user.PlataformaIntegracion.ModoPorSucursal,
      id_rol_usr_web : user.IdRolUsrWeb
    };
  }

  // SC CATFER-9 se define para obtener los datos del usuario web
  getUsuarioWeb(id:number, token:string){
    this.usuarioService.getUsuarioWeb(id, token).subscribe((resp) => {
      if(resp.Data){
        this.usuarioWeb = resp.Data;
        console.log("entro con usuario");
      }
    });
  }
  // SC CATWEB-343 28/09/2021 Funcion click boton de ingreso como invitado.
  loginInvitado() {
    this.loginForm.setValue({
      usuario: this.config.sesion.invitado.user_invitado,
      password: this.config.sesion.invitado.pass_invitado,
      recordarme: false,
    });

    this.login();
  }

  // SC CATWEB-343 28/09/2021 Funcion redirecciona a la pagina segun la page que se pasa por parametro.
  pageRedirect(page: string) {
    switch (page) {
      case 'H':
        this.router.navigateByUrl('/home');
        break;
      case 'P':
        this.router.navigateByUrl('/productos');
        break;
      case 'O':
        this.router.navigateByUrl('/ofertas');
        break;
      default:
        break;
    }
  }

  //MV CATWEB-322 Funcion para agregar usuario a usuariosGuardados si selecciona Recordarme y setear usuariosGuardados en localStorage
  private recordarUsuario(usuario: string) {
    if (
      this.loginForm.get('recordarme').value &&
      !this.usuariosGuardados.includes(usuario)
    ) {
      this.usuariosGuardados.push(usuario);
      localStorage.setItem('usuarios', JSON.stringify(this.usuariosGuardados));
    }
  }

  //MV CATWEB-322 Funcion para cargar los usuarios guardados en localStorage y almacenarlos en usuariosGuardados.
  private cargarUsuariosRecordados() {
    if (localStorage.getItem('usuarios') !== null) {
      this.usuariosGuardados = JSON.parse(localStorage.getItem('usuarios'));
    } else {
      this.usuariosGuardados = [];
    }
  }

  // SC CATFER-9 Verifica si tiene una sucursal asociada en caso tenga habilitado el modo por SucursalService.
  private checkSucursal(modo_por_sucursal: string, sucursales:any, nombre_cliente: string) {
    let result = false;
    let id_sucursal = sucursales && sucursales.length > 0 ? sucursales[0].Id: -1;
    let checkSuc =
      modo_por_sucursal === 'S' && (typeof id_sucursal != 'number' || id_sucursal < 0);
    if (checkSuc) {
      this.toastr.error(`${nombre_cliente} no tiene sucursal asociada`);
    }else{
      result = true;
    }
    return result;
  }
}
